import {
  FEEDBACK_LOADING,
  LOAD_FEEDBACK_LIST,
  CREATE_FEEDBACK,
  UPDATE_FEEDBACK,
  DELETE_FEEDBACK,
  OPEN_FEEDBACK,
  CREATE_NEW_LABEL_TOGGLE,
  LOAD_LABEL_MANAGER,
} from '../actions/feedbackActions';

const initialState = {
  loadingFeedback: false,
  feedbackList: [],
  totalPages: 1,
  perPage: 20,
  selectedFeedback: [],
  isCreateNewLabel: false,
  labelManager:''
};

export default ( state = initialState, action ) => {
  switch (action.type) {
    case FEEDBACK_LOADING:
      return {
        ...state,
        loadingFeedback : action.payload,
      };

    case LOAD_FEEDBACK_LIST:
      const perPage =
        action && action.payload && action.payload.perPage
          ? action.payload.perPage : initialState.perPage;
      const totalPages = action.payload.data
        ? Math.ceil(action.payload.data.length / perPage)
        : initialState.perPage;

      return {
        ...state,
        feedbackList: action.payload.data,
        totalPages,
      };

    case CREATE_FEEDBACK:
      return {
        ...state,
        feedbackList: [...state.feedbackList, action.payload],
      };

    case UPDATE_FEEDBACK:
      const updatedFeedbackList =
        state.feedbackList.filter(feedback => feedback._id !== action.payload._id);
      return {
        ...state,
        feedbackList: [...updatedFeedbackList, action.payload],
      };

    case DELETE_FEEDBACK:
      const filteredFeedback =
        state.feedbackList.filter(feedback => feedback._id !== action.payload);
      return {
        ...state,
        feedbackList: filteredFeedback,
      };

    case OPEN_FEEDBACK:
      return {
        ...state,
        selectedFeedback: action.payload,
      };
    case CREATE_NEW_LABEL_TOGGLE:
      return {
        ...state,
        isCreateNewLabel: action.payload,
      };

    case LOAD_LABEL_MANAGER:
      return {
        ...state,
        labelManager: action.payload,
      };

    default:
      return { ...state };
  }

};
